import React from "react";
import { ApiValidationError } from "../types";
import { toValidationError } from "../apiMapper";
import { describeValidationError } from "./validationCopy";

interface Props {
  errors: ApiValidationError[];
  total: number;
}

const ValidationErrors: React.FC<Props> = ({ errors, total }) => {
  const groups = errors.reduce<Record<string, ApiValidationError[]>>(
    (acc, error) => {
      const sheet = String(error.details?.sheet_name || "File");
      acc[sheet] = [...(acc[sheet] || []), error];
      return acc;
    },
    {},
  );

  return (
    <div className="validation-errors">
      {Object.keys(groups).map((sheet) => (
        <div className="validation-group" key={sheet}>
          <div className="validation-sheet">{sheet}</div>
          <ul>
            {groups[sheet].map((error, index) => (
              <li key={`${error.code}-${index}`}>
                {error.details?.row_number ? (
                  <strong>Row {String(error.details.row_number)}: </strong>
                ) : null}
                {describeValidationError(
                  toValidationError(error.code, error.details),
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
      {total > errors.length && (
        <div className="validation-more">and {total - errors.length} more</div>
      )}
    </div>
  );
};

export default ValidationErrors;
